import { render, staticRenderFns } from "./SignUpDialog.vue?vue&type=template&id=7122639d"
import script from "./SignUpDialog.vue?vue&type=script&lang=js"
export * from "./SignUpDialog.vue?vue&type=script&lang=js"
import style0 from "./SignUpDialog.vue?vue&type=style&index=0&id=7122639d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7122639d')) {
      api.createRecord('7122639d', component.options)
    } else {
      api.reload('7122639d', component.options)
    }
    module.hot.accept("./SignUpDialog.vue?vue&type=template&id=7122639d", function () {
      api.rerender('7122639d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/SignUpDialog.vue"
export default component.exports